
// This just creates a generic event bus, that can be used in a variety of ways
import Vue from 'vue';

export default new Vue();
